module.exports = __webpack_public_path__ + "img/top.69d65210.jpg";